import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Modal,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { RxCross1 } from "react-icons/rx";
import {
  fetchCategoriesProduct,
  getLabelPurchase,
} from "../../../../services/purchaseApi";
import { useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalFilterCategory = ({ open, setOpen, reqBody, setReqBody }) => {
  const [tempLabelArr, setTempLabelArr] = useState([]);

  const handleClose = () => {
    setTempLabelArr([]);
    setOpen(false);
  };

  const { data: dataLabel, isFetching: isFetchingLabel } = useQuery({
    queryKey: ["label-list", open],
    queryFn: () => getLabelPurchase(1, 100, ""),
    enabled: open === true,
  });

  useEffect(() => {
    if (open) {
      setTempLabelArr(reqBody.label_ids);
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Golongan</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[40vh] ">
            {dataLabel && !isFetchingLabel ? (
              <>
                {dataLabel.map((item, i) => (
                  <FormControlLabel
                    sx={{ width: "100%", marginBottom: 1 }}
                    control={<Checkbox value={item.id} />}
                    label={item.label_name}
                    checked={tempLabelArr.includes(item.id)}
                    onChange={() => {
                      const index = tempLabelArr.findIndex(
                        (id) => id === item.id
                      );

                      setTempLabelArr(
                        index < 0
                          ? [...tempLabelArr, item.id]
                          : [
                              ...tempLabelArr.slice(0, index),
                              ...tempLabelArr.slice(index + 1),
                            ]
                      );
                    }}
                  />
                ))}
              </>
            ) : (
              <CircularProgress size={20} />
            )}
          </div>

          <div className="flex justify-end items-center px-8 py-4 gap-2">
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#F1FAF0] text-[#6F955B] border-[#6F955B] hover:bg-gray-300"
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300"
              onClick={() => {
                setReqBody((prevVal) => ({
                  ...prevVal,
                  label_ids: tempLabelArr,
                  offset: 1,
                }));
                handleClose();
              }}
            >
              Simpan
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalFilterCategory;
